/***
 * @ngdoc directive
 * @name BB:bbCompanies
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Loads a list of companies for the currently in scope company
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 *
 * @property {integer} id The company id
 * @property {string} name The company name
 * @property {integer} address_id Company address id
 * @property {string} country_code Company country code
 * @property {string} currency_code The company currency code
 * @property {string} timezone The company time zone
 * @property {integer} numeric_widget_id The numeric widget id of the company
 * @property {object} validator The validator service - see {@link BB:Validator Validator Service}
 * @property {object} alert The alert service - see {@link BB:Alert Alert Service}
 *
 *  <example module="BB">
 *    <file name="index.html">
 *   <div bb-api-url='https://uk.bookingbug.com'>
 *   <div  bb-widget='{company_id:21}'>
 *     <div bb-company>
 *       <p>id: {{company.id}}</p>
 *        <p>name: {{company.name}}</p>
 *        <p>address_id: {{company.address_id}}</p>
 *        <p>country_code: {{company.country_code}}</p>
 *        <p>currency_code: {{company.country_code}}</p>
 *        <p>timezone: {{company.timezone}}</p>
 *        <p>numeric_widget_id: {{company.numeric_widget_id}}</p>
 *      </div>
 *     </div>
 *     </div>
 *   </file>
 *  </example>
 *///

angular.module('BBPublicBooking').directive('bbCompanies', () => {
        return {
            restrict: 'AE',
            replace: true,
            scope: true,
            controller: companyListCtrl
        };
    }
);

function companyListCtrl($scope, $rootScope, $q, $attrs, LoadingService) {
    'ngInject';

    const loader = LoadingService.$loader($scope).notLoaded();

    const options = $scope.$eval($attrs.bbCompanies);

    $rootScope.connection_started.then(() => {
        if ($scope.bb.company.companies) {
            $scope.init($scope.bb.company);
            return $rootScope.parent_id = $scope.bb.company.id;
        } else if ($rootScope.parent_id) {
            $scope.initWidget({ company_id: $rootScope.parent_id, first_page: $scope.bb.current_page });
            return;
        } else {
            return $scope.init($scope.bb.company);
        }
    }
        , err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));

    $scope.init = (comp) => {

        $scope.companies = $scope.bb.company.companies;
        if (!$scope.companies || ($scope.companies.length === 0)) {
            $scope.companies = [$scope.bb.company];
        }

        if ($scope.companies.length === 1) {
            $scope.skipThisStep();
            $scope.selectItem($scope.companies[0]);
        } else {
            if (options && options.hide_not_live_stores) {
                $scope.items = $scope.companies.filter(c => c.live);
            } else {
                $scope.items = $scope.companies;
            }
        }
        return loader.setLoaded();
    };

    $scope.selectItem = (item, route) => {

        // if company id is passed in, set the company id to this number
        let company_id;
        if (angular.isNumber(item)) {
            company_id = item;
        } else {
            company_id = item.id;
        }

        loader.notLoaded();
        const prms = { company_id };
        return $scope.initWidget(prms);
    };

    // TODO move this into a mothercare js file
    return $scope.splitString = function (company) {
        const arr = company.name.split(' ');
        return arr[2] ? arr[2] : '';
    };
}




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/companies/bb_companies.directive.js